import styled from 'styled-components';
import { theme } from 'ui/theme-color';

export const FileTitleContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-around;
  width: 100%;
`;

export const FilesContainer = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const FileLabelContainer = styled.label`
  border: 2px dashed;
  border-radius: 8px;
  width: 100%;
  padding: 2rem;
  cursor: pointer;

  border-color: ${(props) =>
    props.isDragging ? theme.palette.purple.main : theme.palette.colors.grey};

  background-color: ${(props) =>
    props.isDragging ? theme.palette.lightgrey.main : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 1rem;

  :hover {
    background-color: ${() => theme.palette.lightgrey.main};
  }
`;

export const FileInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  width: 70%;
`;

export const AttachedFilesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

export const AttachedFile = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: ${() => `1px solid ${theme.palette.primary.main}`};
  border-radius: 8px;
  justify-content: space-between;
  padding-right: 0.5rem;
`;

export const AttachedFileImage = styled.div`
  border: ${() => `1px solid ${theme.palette.primary.main}`};
  border-radius: 4px;
  background-color: ${(props) =>
    props.file.type.startsWith('image/')
      ? theme.palette.lightgrey.main
      : props.file.type.startsWith('application/pdf')
        ? theme.palette.error.main
        : theme.palette.lightgrey.main};
  padding: 0.5rem;
  margin: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row-reverse;
  gap: 1rem;
  width: 100%;
`;
